import React from 'react';
import type { TextStyle, ViewProps } from 'react-native';
import { StyleSheet } from 'react-native';
import { theme, TYPE_CONFIG } from '@garnish/constants';

import { useResponsive } from '../../../../../hooks';
import { TitleText } from '../../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const PageHeroHeaderTitle = (props: PageHeroHeaderTitleProps) => {
  const { children, paletteStyle } = props;

  const { match } = useResponsive();

  const titleResponsiveStyles = match([
    styles.titleXS,
    styles.titleSM,
    styles.titleSM,
    styles.titleLG,
  ]);
  const titleStyles = [styles.title, titleResponsiveStyles, paletteStyle];
  const titleSize = match([0, 3] as const);

  return (
    <TitleText size={titleSize} style={titleStyles} bold>
      {children}
    </TitleText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  titleXS: {
    ...TYPE_CONFIG.TITLE['40'],
    marginBottom: theme.spacing['4'],
  },
  titleSM: {
    ...TYPE_CONFIG.TITLE['80'],
    marginBottom: theme.spacing['6'],
  },
  titleLG: {
    ...TYPE_CONFIG.TITLE['120'],
    marginBottom: theme.spacing['10'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type PageHeroHeaderTitleProps = {
  readonly children: ViewProps['children'];
  readonly paletteStyle: TextStyle;
};
